import { render, staticRenderFns } from "./PolizasRHImportView.vue?vue&type=template&id=1b6755fc&"
import script from "./PolizasRHImportView.vue?vue&type=script&lang=js&"
export * from "./PolizasRHImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports